import WorkItemAttribute from '~/vue_shared/components/work_item_attribute.vue';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { __, sprintf } from '~/locale';
export default {
    name: 'IssueMilestone',
    components: {
        WorkItemAttribute
    },
    props: {
        milestone: {
            type: Object,
            required: true
        }
    },
    computed: {
        popoverAttributes () {
            return {
                'data-reference-type': 'milestone',
                'data-placement': 'top',
                'data-milestone': getIdFromGraphQLId(this.milestone.id)
            };
        }
    },
    methods: {
        createAriaLabel () {
            return sprintf(__(`Milestone: %{milestoneTitle}`), {
                milestoneTitle: this.milestone.title
            });
        }
    }
};
